import React, { useState, useEffect } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import api from '../api';
import KpiCard from '../components/KpiCard';
import DateRange from '../components/DateRange';

function daysAgo(n) { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString().split('T')[0]; }
function today() { return new Date().toISOString().split('T')[0]; }
function fmtHuf(v) { return Math.round(v).toLocaleString('hu-HU'); }

export default function Dashboard() {
  const [from, setFrom] = useState(daysAgo(30));
  const [to, setTo] = useState(today());
  const [kpi, setKpi] = useState(null);
  const [trend, setTrend] = useState([]);
  const [costSummary, setCostSummary] = useState([]);

  useEffect(() => {
    api.kpi.overview(from, to).then(setKpi).catch(() => {});
    api.kpi.profitTrend(30).then(d => setTrend(d.reverse())).catch(() => {});
    api.costs.summary(from, to).then(setCostSummary).catch(() => {});
  }, [from, to]);

  const catLabels = { ai: 'AI (OpenAI)', cloud: 'Cloud (Firebase)', server: 'Szerver (Hetzner)' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Áttekintés</h1>
        <DateRange from={from} to={to} onChange={(f, t) => { setFrom(f); setTo(t); }} />
      </div>

      {kpi && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 12, marginBottom: 24 }}>
          <KpiCard label="Bevétel" value={fmtHuf(kpi.total_revenue_huf)} suffix="Ft" />
          <KpiCard label="Költség" value={fmtHuf(kpi.total_cost_huf)} suffix="Ft" color="#f87171" />
          <KpiCard label="Profit" value={fmtHuf(kpi.profit_huf)} suffix="Ft" color={kpi.profit_huf >= 0 ? '#34d399' : '#f87171'} />
          <KpiCard label="Letöltések" value={kpi.total_downloads} />
          <KpiCard label="Narrációk" value={kpi.total_narrations} />
          <KpiCard label="Költség/narráció" value={kpi.avg_cost_per_narration?.toFixed(2)} suffix="$" color="#fbbf24" />
          <KpiCard label="ARPU" value={fmtHuf(kpi.arpu_huf)} suffix="Ft" />
          <KpiCard label="USD/HUF" value={kpi.usd_huf?.toFixed(1)} />
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
        <div className="card">
          <h3 style={{ fontSize: 15, marginBottom: 16, color: '#8b8fa3' }}>Profit trend (30 nap) - Ft</h3>
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart data={trend}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2e3a" />
              <XAxis dataKey="date" tick={{ fill: '#8b8fa3', fontSize: 11 }} tickFormatter={v => v.slice(5)} />
              <YAxis tick={{ fill: '#8b8fa3', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#1a1d27', border: '1px solid #2a2e3a', borderRadius: 8, color: '#e4e6eb' }} formatter={(v) => Math.round(v) + ' Ft'} />
              <Area type="monotone" dataKey="revenue_huf" stroke="#34d399" fill="rgba(52,211,153,0.15)" name="Bevétel" />
              <Area type="monotone" dataKey="cost_huf" stroke="#f87171" fill="rgba(248,113,113,0.15)" name="Költség" />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="card">
          <h3 style={{ fontSize: 15, marginBottom: 16, color: '#8b8fa3' }}>Költség megoszlás</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={costSummary.map(c => ({ ...c, name: catLabels[c.category] || c.category }))}>
              <CartesianGrid strokeDasharray="3 3" stroke="#2a2e3a" />
              <XAxis dataKey="name" tick={{ fill: '#8b8fa3', fontSize: 11 }} />
              <YAxis tick={{ fill: '#8b8fa3', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#1a1d27', border: '1px solid #2a2e3a', borderRadius: 8, color: '#e4e6eb' }} />
              <Bar dataKey="total_usd" fill="#00d4ff" radius={[6, 6, 0, 0]} name="USD" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
